export const enum FullscreenAction {
    EnterBrowser = 'enter-browser',
    ExitBrowser = 'exit-browser',
    SetWindowed = 'set-windowed',
    None = 'none',
}

export const enum FullscreenResetReason {
    CallCancelled = 'call-cancelled',
    SharingEnded = 'sharing-ended',
}

interface GetFullscreenActionParams {
    isMeetingFullscreenEnabled: boolean;
    isFullscreen: boolean;
    domFullscreenState: boolean;
    newState: boolean;
}

export const getFullscreenAction = ({
    isMeetingFullscreenEnabled,
    isFullscreen,
    domFullscreenState,
    newState,
}: GetFullscreenActionParams): FullscreenAction => {
    if (isMeetingFullscreenEnabled) {
        return isFullscreen === newState ? FullscreenAction.None : FullscreenAction.SetWindowed;
    }

    if (isFullscreen === newState && domFullscreenState === newState) {
        return FullscreenAction.None;
    }

    return newState ? FullscreenAction.EnterBrowser : FullscreenAction.ExitBrowser;
};

export const getFullscreenResetAction = ({
    isMeetingFullscreenEnabled,
    isFullscreen,
    reason,
}: {
    isMeetingFullscreenEnabled: boolean;
    isFullscreen: boolean;
    reason: FullscreenResetReason;
}): FullscreenAction => {
    if (isMeetingFullscreenEnabled && reason === FullscreenResetReason.CallCancelled && isFullscreen) {
        return FullscreenAction.SetWindowed;
    }

    return FullscreenAction.ExitBrowser;
};

export const shouldShowMeetingFullscreenButton = ({
    isMeetingFullscreenEnabled,
    isJoined,
    isScreenSharingActive,
}: {
    isMeetingFullscreenEnabled: boolean;
    isJoined: boolean;
    isScreenSharingActive: boolean;
}) => {
    return isMeetingFullscreenEnabled && isJoined && !isScreenSharingActive;
};

export const shouldHideVideoGridInFullscreen = ({
    isMeetingFullscreenEnabled,
    isFullscreen,
}: {
    isMeetingFullscreenEnabled: boolean;
    isFullscreen: boolean;
}) => {
    return isFullscreen && !isMeetingFullscreenEnabled;
};

export const shouldCloseWindowedFullscreenByEscape = ({
    isMeetingFullscreenEnabled,
    isFullscreen,
    key,
}: {
    isMeetingFullscreenEnabled: boolean;
    isFullscreen: boolean;
    key: string;
}) => {
    return isMeetingFullscreenEnabled && isFullscreen && key === 'Escape';
};
